<template>

    <div>
    
        <v-text-field
            v-model="dataValue"
            :label="collectionItem.id"
            :hint="collectionItem.caption"
            :persistent-hint="true"
            :rules="validationPhoneRules" 
            :placeholder="collectionItem.id"
            :background-color="backgroundColor"
            v-mask="masks.phone"
            v-if="collectionItem.type === 'phone'"

        >
            <template
                    v-slot:append-outer
            >
                <div style="display:flex; align-items:center; justify-content:center; height:100%;">
                    <v-checkbox 
                            v-model="dataValueAttribute"
                            label="Allow Text Messages"
                            dense
                            hide-details
                            style="min-height:20px; height:20px; padding:0; margin:0; line-height:20px;"
                    />
                </div>
            </template>        
        </v-text-field>
        <v-text-field
            v-model="dataValue"
            :label="collectionItem.id"
            :hint="collectionItem.caption"
            :persistent-hint="true"
            :rules="validationDateRules" 
            :placeholder="collectionItem.id"
            :background-color="backgroundColor"
            v-mask="masks.dob"
            v-else-if="collectionItem.type === 'dob'"
        />

        <v-select flat 
            v-model="dataValue"
            :label="collectionItem.id"
            :hint="collectionItem.caption"
            :persistent-hint="true"
            :rules="validationRules" 
            :placeholder="collectionItem.id"
            :background-color="backgroundColor"
            :items="listItems"
            item-text="name"
            item-value="id"
            v-else-if="collectionItem.type === 'list'"
        />

               

        <v-select flat 
            v-model="dataValue"
            :label="collectionItem.id"
            :hint="collectionItem.caption"
            :persistent-hint="true"
            :rules="validationRules" 
            :placeholder="collectionItem.id"
            :background-color="backgroundColor"
            :items="providers"
            item-text="name"
            item-value="value"
            v-else-if="collectionItem.type === 'provider'"
        />
    

        <v-text-field
            v-model="dataValue"
            :label="collectionItem.id"
            :hint="collectionItem.caption"
            :rules="validationRules" 
            :placeholder="collectionItem.id"
            :background-color="backgroundColor"
            :persistent-hint="true"
            v-else
        />

    </div>

</template>

<script>
    import userPicker from '@/components/searches/user-picker';
    export default {
        components: {
            'user-picker': userPicker
        },
        props: {  
            value: {
                default: null
            },
            attribute: {
                default: null
            },            
            collectionItem: {
                type: Object,
                default: () => {}
            },
            backgroundColor: {
                default: 'white',
                type: String
            },
            outlined: {
                default: false,
                type: Boolean
            },
        },
        data: () => ({
            validation_rules: {
                required: value => !!value || 'Required.',
                //min: v => v.length >= 8 || 'Min 8 characters',
                phone: (number, other) => {
                    const pattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                    return pattern.test(number) || 'Invalid number. Please use (###) ###-####';
                },
                validateEmail: (v, message) => {
                    const emailRegex = /.+@.+\..+/
                    if (!v) {
                        return true
                    }
                    return emailRegex.test(v) || (message || 'Invalid Email address')
                },
                dob: date => {
                    const pattern = /^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/([12][0-9]{3})$/;
                    return pattern.test(date) || 'Invalid date. Please use mm/dd/yyyy';
                },
                minyear : date => {

                    if (date && date.length == 10) {

                        let pieces = date.split('/')
                        let year = parseInt(pieces[2])
                        if (year < 1900) {
                            return 'Year must be greater than 1900'
                        } 
                        let today = new Date();
  
                        if (year > today.getFullYear() +1)     {
                            return 'Invalid Future Year'
                        }                 
                    }
                    return true
                }              
            },  
            masks: {
                phone: '(###) ###-####',
                dob: '##/##/####'
            },         
        }),
        async mounted() {
            if (this.collectionItem.default) {
                this.$emit('input', this.collectionItem.default)
            }
        },        
        methods: {
            changed (params) {
                this.$emit('changed', this.value)
            }
        },
        computed: {
            dataValue: {
                get: function() {
                    return this.value ;
                },
                set: function(newValue) {
                    this.$emit('input', newValue)
                }
            },
            dataValueAttribute: {
                get: function() {
                    return this.attribute ;
                },
                set: function(newValue) {
                    this.$emit('update:attribute', newValue)
                }
            },            
            validationRules () {
                return [this.validation_rules.required]
            },
            validationPhoneRules () {
                return [this.validation_rules.required, this.validation_rules.phone]
            },
            validationDateRules () {
                return [this.validation_rules.required, this.validation_rules.dob, this.validation_rules.minyear]
            },
            listItems () {
                let arr = []
                console.log('collectionItem', this.collectionItem)

                let captionsArray = this.collectionItem.attributes.captions.split(',')
                let valuesArray = this.collectionItem.attributes.values.split(',')
                for (let i=0;i<captionsArray.length;i++) {
                    arr.push({id: valuesArray[i], name: captionsArray[i]})
                }
                return arr
            },
            providers () {
                let arr = []

                if (this.collectionItem.attributes.providers) {
                    arr = this.collectionItem.attributes.providers
                }
                return arr
            }
        },
        watch: {

        }
    }
</script>
